import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  _change_password,
  _generate_otp,
  _get_profile,
  _change_login_pin,
  _verify_otp,
} from "../../../../common/axios_services";
import { LoadingOutlined } from "@ant-design/icons";
import { fetchData, profileData } from "../../../../slices/profileSlice";
import { useResendTimer } from "../../../../hooks/useResendTimer";
import TopNav from "../../../../components/top-nav";
import security_pad from "../../../../assets/images/illustrations/Security_pad.mp4";
import { Button, Form, Input, Modal, Spin, notification } from "antd";
import PinInput from "../../../../components/Restaurant/PinInput";

const UpdateLoginPin = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [VerActivated, setVerActivated] = useState(false);
  const [updatePinVisible, setUpdatePinVisible] = useState(false);
  const [updateCount, setUpdateCount] = useState(0);
  const [loadingOTPData, setLoadingOTPData] = useState(false);
  const [otp, setOtp] = useState(false);
  const [verifiedOtp, setVerifiedOtp] = useState(false);
  const [updatingPin, setUpdatingPin] = useState(false);
  const [loginPinUpdateDisplay, setLoginPinUpdateDisplay] = useState(0);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [reGen, setReGen] = useState(false);
  const [userOTP, setUserOTP] = useState("");
  const [revealPinMessage, setRevealPinMessage] = useState("");

  const profileInfo = useSelector((state) => state.userProfile.dataFetched);
  const {
    timer: resendTimer,
    startTimer: startResendTimer,
    stopTimer: stopResendTimer,
  } = useResendTimer(60);

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      placement: "bottomRight",
      message: title ? title : "",
      description: message ? message : "",
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );
  const newAntIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const {
    handleSubmit: editPasswordHandleSubmit,
    control: editPasswordControl,
  } = useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchUser = async () => {
    try {
      const user_profile = await _get_profile();
      dispatch(fetchData(true));
      dispatch(profileData(user_profile?.data?.data));
      setVerActivated(user_profile?.data?.data?.login_2fa);
      if (user_profile?.data?.data?.email_otp) {
        setOtp(user_profile?.data?.data?.email_otp);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate(`/signin?redir=loyalty`);
        }
        dispatch(profileData(false));
        dispatch(fetchData(false));
      } else {
      }
    }
  };
  useEffect(() => {
    fetchUser();
  }, [updateCount]);

  const updatePin = async (value) => {
    setRevealPinMessage("");
    if (value.new_pin !== value.confirm_pin) {
      setRevealPinMessage("New pin and confirm pin are not equal");
    } else {
      setUpdatingPin(true);
      try {
        const changeLoginPin = await _change_login_pin({
          email: profileInfo?.email,
          new_pin: value.new_pin,
          confirm_new_pin: value.confirm_pin,
          otpCode: userOTP,
        });
        setLoadingSpinner(false);
        openNotificationWithIcon("success", null, "Login PIN set successfully");
        setUpdatingPin(false);
        setLoadingSpinner(false);
        setLoginPinUpdateDisplay(0);
        setUpdatePinVisible(false);
        setVerifiedOtp(false);
        stopResendTimer();
        navigate("/settings");
      } catch (err) {
        if (err.response) {
          if (err.response.data.message === "Unauthorized") {
            openNotificationWithIcon(
              "error",
              err?.response?.data?.title,
              err?.response?.data?.message,
            );
            navigate("/signin");
          }
          openNotificationWithIcon(
            "error",
            err?.response?.data?.title,
            err?.response?.data?.message,
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Something went wrong",
            err?.message,
          );
        }
        setUpdatingPin(false);
        setLoadingSpinner(false);
      }
    }
  };

  const genOtp = async () => {
    setLoadingOTPData(true);
    try {
      const generate_otp = await _generate_otp();
      setLoadingOTPData(false);
      setUpdateCount(updateCount + 1);
      setOtp(true);
      setReGen(false);
      startResendTimer();
      openNotificationWithIcon(
        "success",
        generate_otp?.data?.title,
        generate_otp?.data?.message,
      );
    } catch (err) {
      setLoadingOTPData(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.title,
            err?.response?.data?.message,
          );
          navigate("/signin");
        }
        openNotificationWithIcon(
          err?.response?.data?.status,
          err?.response?.data?.title,
          err?.response?.data?.message,
        );
      } else {
        openNotificationWithIcon("error", "Something went wrong", err.message);
      }
    }
  };

  const VerifyOtp = async (values) => {
    setLoadingOTPData(true);
    try {
      const verifyOtp = await _verify_otp({
        email: profileInfo?.email,
        otpCode: values.otp,
      });
      setLoadingOTPData(false);
      setVerifiedOtp(true);
      setUserOTP(values.otp);
      setLoginPinUpdateDisplay(1);
      openNotificationWithIcon(
        "success",
        verifyOtp?.data?.title,
        verifyOtp?.data?.message,
      );
    } catch (err) {
      setLoadingOTPData(false);
      setVerifiedOtp(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.title,
            err?.response?.data?.message,
          );
          navigate("/signin");
        } else {
          if (err.response.data.message.includes("expired")) {
            setOtp(false);
            setReGen(true);
          } else {
            setReGen(false);
          }
          openNotificationWithIcon(
            "error",
            err?.response?.data?.message || err.message,
          );
        }
      } else {
        openNotificationWithIcon("error", "Something went wrong", err.message);
      }
    }
  };

  return (
    <div>
      <Spin spinning={loadingSpinner} indicator={newAntIcon}>
        <div className="profile-display settings-display form-page">
          <TopNav title="Update Login PIN" />
          <div className="display-main-content white-b">
            <div className="contain">
              <div className="mt_4">
                <div>
                  <div>
                    {/* {errorMessage.length ? <p className="form-error mb_3">{errorMessage}</p> : ""} */}
                  </div>
                  <div className="accountProtection  my-20 flex justify-center items-center">
                    <form>
                      <div className="sh">
                        <div className="form-group ">
                          <button
                            className="py-3 px-5 w-full font-gilroyBold text-[15px] rounded-xl bg-[green] text-white "
                            type="button"
                            onClick={() => {
                              setUpdatePinVisible(true);
                              genOtp();
                            }}
                          >
                            Generate Login OTP
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="flex mt-28 flex-col justify-center items-center">
                    <video
                      src={security_pad}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="w-3/5 h-3/5 my-5 rounded-lg shadow-md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
      <Modal
        centered={true}
        className="airtimeModal"
        open={updatePinVisible}
        closable={false}
        maskClosable={false}
        footer={null}
      >
        <div>
          {verifiedOtp ? (
            <div className="">
              <h4 className="modal-title">Update Login Pin</h4>
              <div style={{ marginTop: "5%" }}></div>
              {revealPinMessage ? (
                <p className="error-message">{revealPinMessage}</p>
              ) : (
                ""
              )}
              <Form
                layout="vertical"
                style={{ maxWidth: 600 }}
                onFinish={updatePin}
                autoComplete="off"
              >
                <Form.Item label="New Pin" name="new_pin">
                  <PinInput
                    name="new_pin"
                    onChange={(value) => {
                      form.setFieldsValue({ new_pin: value });
                    }}
                  />
                </Form.Item>
                <Form.Item label="Confirm Pin" name="confirm_pin">
                  <PinInput
                    name="confirm_pin"
                    onChange={(value) => {
                      form.setFieldsValue({ confirm_pin: value });
                    }}
                  />
                </Form.Item>
                <div className="d-flex  flex gap-8" style={{ gap: "5px" }}>
                  {updatingPin ? (
                    <Button
                      type="primary"
                      className={"bg-gray-900"}
                      disabled
                      loading
                    >
                      Updating Pin
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      className={"bg-gray-900"}
                      htmlType="submit"
                    >
                      Update Pin
                    </Button>
                  )}
                  <Button
                    onClick={() => {
                      setUpdatePinVisible(false);
                      setVerifiedOtp(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          ) : (
            <div className="">
              <h4 className="modal-title">Generate Otp</h4>
              <p className="">An Otp would been sent to your email.</p>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-3 mb-3">
                <p className=" text-yellow-800 mb-2">
                  <strong>Didn't receive the OTP?</strong> Check your spam or
                  junk folder. Need to update your email?{" "}
                  <a
                    href="/profile/update-email"
                    style={{
                      color: "#1890ff",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}
                  >
                    Change email address
                  </a>
                </p>
              </div>
              <div style={{ marginTop: "5%" }}></div>
              {revealPinMessage ? (
                <p className="error-message">{revealPinMessage}</p>
              ) : (
                ""
              )}
              <Form
                layout="vertical"
                style={{ maxWidth: 600 }}
                onFinish={VerifyOtp}
                autoComplete="off"
              >
                <Form.Item label="Otp" name="otp">
                  <input
                    className="w-full focus:ring-green-500  px-10 py-4"
                    inputMode="numeric"
                    type="number"
                    placeholder="Enter Otp"
                  />
                </Form.Item>
                <div className="d-flex flex gap-5" style={{ gap: "5px" }}>
                  <div className="flex justify-between">
                    {loadingOTPData ? (
                      <Button
                        type="primary"
                        className={"bg-gray-900"}
                        loading
                        disabled
                      >
                        Verifying Otp
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        className={"bg-gray-900"}
                        htmlType="submit"
                      >
                        Verify Otp
                      </Button>
                    )}
                  </div>
                  <Button
                    type="dashed"
                    disabled={resendTimer > 0 || loadingOTPData}
                    onClick={genOtp}
                  >
                    {resendTimer > 0
                      ? `Resend in ${resendTimer}s`
                      : "Resend OTP"}
                  </Button>
                  <Button
                    onClick={() => {
                      setUpdatePinVisible(false);
                      setVerifiedOtp(false);
                      stopResendTimer();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default UpdateLoginPin;
